// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"bbdf0d6b","74":"deac8646","215":"52a5b196","223":"f72cb762","275":"8ceb099b","409":"c3edc0f3","422":"758dea78","466":"51c0738f","479":"2e82b033","775":"a21af813","928":"a20aa82c","939":"ace95f3e"}[chunkId] + ".chunk.js";
};